import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-chat-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './delete-chat-modal.component.html',
  styleUrl: './delete-chat-modal.component.css'
})
export class DeleteChatModalComponent {
  @Input() chatTitle?: string;
  @Output() deleteConfirmed = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onCancel(): void { 
    this.activeModal.dismiss(); 
  }

  onDelete(): void { 
    this.deleteConfirmed.emit(); 
  }
}
